import { SerpDisplayType } from '~/analytics/ActionAnalytics/actions/actionTypes';
import { ResultType } from '~/core/results/types/results.type';
import { SERPConfirmationEventType, SERPEvent, SERPEventType } from '../SERPEvents';

export type GoToResultEventDetail = {
    data: {
        searchQuery: string;
        resultsCount: number;
        resultType: ResultType;
        url: string;
        order: number;
        serpType: SerpDisplayType;
        button: number;
        key: string;
    };
    deliveryConfirmations: [
        SERPConfirmationEventType.GO_TO_RESULT_GA_CONFIRM,
        SERPConfirmationEventType.GO_TO_RESULT_AA_CONFIRM
    ];
};

export type GoToResultEvent = CustomEvent<GoToResultEventDetail> & {
    type: SERPEventType.GO_TO_RESULT;
};

export const isGoToResultEvent = (event: SERPEvent): event is GoToResultEvent =>
    event.type === SERPEventType.GO_TO_RESULT &&
    'data' in event.detail &&
    typeof event.detail.data === 'object' &&
    'searchQuery' in event.detail.data &&
    'resultsCount' in event.detail.data &&
    'resultType' in event.detail.data &&
    'url' in event.detail.data &&
    'order' in event.detail.data &&
    'button' in event.detail.data &&
    'key' in event.detail.data;
